import { AxiosResponse } from 'axios';
import {
  PartDetailBySupplierInventoryResponse,
  PartSearchResponse,
  XnuupPartIdAutoCompleteResponse
} from '@/main/models/response';
import {
  PartSearchRequest,
  XnuupPartIdAutocompleteFilterRequest
} from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IPartApi {
  abstract getSearchParts(
    request: PartSearchRequest
  ): Promise<AxiosResponse<PaginationResponse<PartSearchResponse>>>;

  abstract getPartDetailBySupplierInventory(request: {
    guid: string;
  }): Promise<AxiosResponse<Result<PartDetailBySupplierInventoryResponse>>>;

  abstract getXnuupPartId(
    request: XnuupPartIdAutocompleteFilterRequest
  ): Promise<
    AxiosResponse<PaginationResponse<XnuupPartIdAutoCompleteResponse>>
  >;

}
